var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "@chakra-ui/react";
import { formatSince } from "@/components/utils";
import { JobBadges } from "./JobBadges";
export var SearchResultsJobDetailsHeaderContent = function (_a) {
    var job = _a.job;
    return (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ variant: "detailsTitle", as: "h2" }, { children: job.title })), _jsx(Text, __assign({ variant: "detailsCompany" }, { children: job.company })), _jsx(Text, __assign({ variant: "detailsLocation" }, { children: job.location })), _jsx(JobBadges, { job: job }), _jsxs(Text, __assign({ variant: "postedAt" }, { children: ["Posted ", formatSince(job.datePublished)] }))] }));
};
